import { connect } from 'react-redux';

import { IApplicationState, TThunkDispatch } from '../../../../types/redux';
import { preparePolygons } from '../../../../mappers/polygons';
import { addGeo } from '../../../../actions/jsonQuery';

import { IPolygonsProps, Polygons as PolygonsComponent } from './Polygons';
import { IJsonQueryPolygon, TCoordinate } from '@cian/api-models/common/json_query';

type TStateProps = Pick<IPolygonsProps, 'polygons' | 'isDrawingMode'>;

interface IDispatchProps {
  addPolygon(polygon: IJsonQueryPolygon): void;
}

const mapStateToProps = (state: IApplicationState): TStateProps => ({
  isDrawingMode: state.drawing.isDrawingMode,
  polygons: preparePolygons(state.filters.jsonQuery).map(polygon => ({
    ...polygon,
    coordinates: polygon.coordinates.map(([a, b]) => [b, a]),
  })),
});

const mapDispatchToProps = (dispatch: TThunkDispatch): IDispatchProps => ({
  addPolygon: polygon => {
    const coordinates: TCoordinate[] = polygon.coordinates.map(([a, b]) => [
      parseFloat(Number(b).toFixed(7)).toString(),
      parseFloat(Number(a).toFixed(7)).toString(),
    ]);

    coordinates.push(coordinates[0]);

    dispatch(
      addGeo({
        ...polygon,
        coordinates,
      }),
    );
  },
});

export const Polygons = connect(mapStateToProps, mapDispatchToProps)(PolygonsComponent);
